export default __webpack_public_path__ + "img/59c34592b3cbc0a612fe6cc8cf6dd036.png";